import * as React from 'react';

import type {OutcomeType} from 'nutshell-graphql-types';
import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {ClosedLeadEmailAutomationCard} from '../cards/closed-lead-email-automation-card';

import {CardsContainer} from './cards-container';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
    outcomeType: OutcomeType;
};

const defaultAutomations = {emailAutomations: []} as const;

export function ClosedLeadMailChimpSubscriptionContainer(props: Props) {
    const automations =
        props.closedLeadAutomations.find(
            (automation) => automation.outcomeType === props.outcomeType
        ) || defaultAutomations;

    const cards = automations.emailAutomations
        .filter((subscription) => {
            return subscription.emailList
                ? subscription.emailList.__typename === 'MailChimpList'
                : true;
        })
        .map((subscription, index) => {
            return (
                <ClosedLeadEmailAutomationCard
                    key={subscription.id}
                    // @ts-expect-error
                    index={index}
                    parentId={props.outcomeType}
                    emailAutomation={subscription}
                    type='MAILCHIMP'
                />
            );
        });

    return (
        <CardsContainer
            type='closedLeadMailChimpSubscriptions'
            isCardBeingDragged={false} // Can't drag on closed lead board for right now
            isLoading={props.isLoading}
            errorMessage={props.errorMessage}
            hideAddCard={false}
            parentId={props.outcomeType}
        >
            {cards}
        </CardsContainer>
    );
}
